import Stack from "@mui/material/Stack";
import { ChatThread } from "et3-ui-library/mui";
import i18n from "../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import { toSubGroupFromCominParameter } from "../../../../../../helpers/et3-convert-array-sub-group";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import { E_KHATTABAT_CONVERSATION_TYPE } from "../../../../../../Types";
import KhattabatMessageBubble from "./message/KhattabatMessageBubble";

const KhattabatConversationThread = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { conversationID } = props;
  const { messages, conversationType } =
    getKhattabatSharedMessagingStore(conversationID);
  const khattabatMessages = messages.get();
  const isOneOTwoConversation =
    conversationType.get() === E_KHATTABAT_CONVERSATION_TYPE.ONE_O_TWO;

  return (
    <ChatThread
      messageCount={khattabatMessages.length}
      emptyLabel={i18n.get("KHATTABAT_CONVERSATION_EMPTY")}
    >
      {toSubGroupFromCominParameter(khattabatMessages).map(
        (subGroupData, subGroupIndex) => (
          <Stack key={subGroupIndex} spacing={0.5}>
            {subGroupData.map((khattabatMessage, index) => (
              <KhattabatMessageBubble
                key={`${khattabatMessage.createdOn}_${index}`}
                khattabatMessage={khattabatMessage}
                isLastInSubGroup={index === subGroupData.length - 1}
                conversationID={conversationID}
                isOneOTwoConversation={isOneOTwoConversation}
              />
            ))}
          </Stack>
        )
      )}
    </ChatThread>
  );
});

export default KhattabatConversationThread;
